import axios from "axios";
import { API_URL } from "../config";

const instance = axios.create({
  baseURL: API_URL, // Aquí usamos la constante
  withCredentials: true, // Para enviar cookies y credenciales
});

export default instance;
